import React from "react";

import "./../../style/overlay-spinner.module.css";

export default function OverlaySpinner() {
    return (
        <div className="container-overlay-spinner">
            <img className="loader" src="/static/assets/dashboard/loading.svg" alt="loading" />
        </div>
    );
}
